import { Injectable } from 'angular-ts-decorators';

import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import { Domain } from '@shared/app/scripts/services/domain';
import type { IConfig } from '@shared/app/scripts/services/config';
import { Transaction } from '@core/app/scripts/services/transaction';

/**
 * Service in the coreModule. It takes care of communication with replenishment
 * resource. Methods are inherited form {@link shared.spynlBase
 * spynlBase} service, and are documented there.
 */
@Injectable('replenishment')
export class Replenishment extends SpynlBase<Object> {
  location: string;
  constructor(
    protected $http: ng.IHttpService,
    protected $q: ng.IQService,
    protected sentry,
    protected domain: Domain,
    protected config: IConfig,
    protected standardErrorParser,
    private transaction: Transaction,
    private uuid,
    private currentSession: CurrentSession,
  ) {
    'ngInject';

    super($http, $q, sentry, domain, config, standardErrorParser, Object);

    this.location = '/replenishment';
  }

  /**
   * Method that returns a new replenishment object
   * @param {string} warehouseId the warehouseId of the warehouse
   * @return {object}
   * It will return a new replenishment object
   */
  newReplenishment(warehouseId: string): any {
    const replenishmentId = this.uuid.v4();
    const SALES_TRANSACTION = 2;
    // TODO define right type for transaction objets
    const newReplenishment: any = this.transaction.getTransactionObject();

    newReplenishment.id = replenishmentId;
    newReplenishment.nr = replenishmentId;
    newReplenishment.buffer_id = replenishmentId;
    newReplenishment.cashier = {
      id: this.currentSession.userId,
      name: this.currentSession.fullname,
      fullname: this.currentSession.fullname,
    };
    newReplenishment.shop = {
      id: warehouseId,
    };

    newReplenishment.device = this.currentSession.userId;
    newReplenishment.device_id = this.currentSession.deviceId;
    newReplenishment.type = SALES_TRANSACTION;

    return newReplenishment;
  }
}
